import { statics } from 'modules/common';
import { PlainDataProvider } from 'modules/data-providers';
import { FC, useMemo } from 'react';
import { useGetStandaloneRequestCurrencies } from 'shared/data/webApp/v2';

import { compareByCodeAndIsCrypto } from './RequestCurrenciesDataProvider.helpers';
import { RequestCurrenciesDataProviderProps } from './RequestCurrenciesDataProvider.types';

const RequestCurrenciesDataProvider: FC<RequestCurrenciesDataProviderProps> = (props) => {
    const { companyId, requestId, integrationCode, children } = props;
    const { data, isLoading } = useGetStandaloneRequestCurrencies(
        {
            path: { companyId, requestId },
        },
        {
            enabled: !integrationCode,
        }
    );

    const currenciesOptions = useMemo(
        () =>
            (data?.currencies || []).sort(compareByCodeAndIsCrypto).map((currency) => {
                const code = currency.code.toLocaleLowerCase();
                const text = currency.isCrypto
                    ? statics.currency.findCryptoCurrencyByCode(code)?.text
                    : statics.currency.findCurrencyByCode(code)?.text;

                return {
                    id: currency.code,
                    text: text || code,
                };
            }),
        [data?.currencies]
    );

    return (
        <PlainDataProvider loading={isLoading} items={currenciesOptions}>
            {children}
        </PlainDataProvider>
    );
};

export default RequestCurrenciesDataProvider;
